import React from 'react';
import { Menu, Bell, Search } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

export default function TopBar({ onMenuClick }) {
  const { adminUser } = useAuth();

  return (
    <header className="h-16 bg-white border-b border-gray-100 flex items-center px-6 gap-4 flex-shrink-0 shadow-sm">
      {/* Hamburger */}
      <button
        onClick={onMenuClick}
        className="lg:hidden btn-icon"
        aria-label="Toggle menu"
      >
        <Menu size={18} />
      </button>

      <div className="flex-1" />

      {/* Right area */}
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-2.5 pl-3 border-l border-gray-200">
          <div className="w-8 h-8 bg-primary-800 rounded-full flex items-center justify-center text-white text-sm font-bold">
            {adminUser?.name?.charAt(0).toUpperCase()}
          </div>
          <div className="hidden md:block">
            <p className="text-sm font-semibold text-gray-900 leading-none">{adminUser?.name}</p>
            <p className="text-xs text-gray-500 mt-0.5 capitalize">{adminUser?.role}</p>
          </div>
        </div>
      </div>
    </header>
  );
}
